import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/feature/SEOHead';

const PHONE = '07760 881212';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const SERVICES_OG_IMAGE = 'https://public.readdy.ai/ai/img_res/32f7452a97e7044da2b103b0ac2e086b.jpg';

const services = [
  {
    id: 'emergency',
    slug: 'emergency-electrician-worksop',
    icon: 'ri-alarm-warning-fill',
    badge: 'MOST URGENT',
    badgeColor: 'bg-red-100 text-red-700',
    title: 'Emergency Electrician Worksop',
    subtitle: 'Fast Response for All Urgent Electrical Problems',
    image: 'https://readdy.ai/api/search-image?query=emergency%20electrician%20arriving%20at%20residential%20house%20at%20night%20with%20professional%20tool%20bag%2C%20urgent%20electrical%20callout%2C%20electric%20van%20parked%20outside%20lit%20house%2C%20dramatic%20night%20scene%20with%20warm%20interior%20lighting%20through%20windows%2C%20realistic%20UK%20trade%20photography&width=900&height=600&seq=service-emergency-worksop&orientation=landscape',
    description: 'When electrical problems strike, you need a qualified electrician fast. We respond quickly to urgent electrical faults across Worksop and the surrounding area — including weekends and bank holidays. Call us and we\'ll do our best to get to you as soon as possible.',
    when: [
      'Complete loss of power to your home',
      'Burning smell or sparking from sockets',
      'Circuit breakers that keep tripping',
      'Electrical fault after a storm or flood',
      'Exposed or damaged wiring found',
      'Partial power loss in part of your home',
    ],
    benefits: [
      { icon: 'ri-time-fill', text: 'Fast response including weekends' },
      { icon: 'ri-map-pin-fill', text: 'Fast response across Worksop' },
      { icon: 'ri-shield-check-fill', text: 'Fully insured & NAPIT registered' },
      { icon: 'ri-money-pound-circle-fill', text: 'Clear pricing before we start' },
    ],
  },
  {
    id: 'rewiring',
    slug: 'rewiring-worksop',
    icon: 'ri-loop-left-fill',
    badge: 'POPULAR',
    badgeColor: 'bg-amber-100 text-amber-700',
    title: 'Rewiring Worksop',
    subtitle: 'Complete House Rewiring by Qualified Electricians',
    image: 'https://readdy.ai/api/search-image?query=electrician%20installing%20new%20electrical%20wiring%20cables%20in%20wall%20cavity%20of%20UK%20home%2C%20rewiring%20house%20interior%2C%20professional%20trade%20work%20with%20new%20cables%2C%20white%20walls%20partially%20opened%2C%20neat%20cable%20installation%2C%20bright%20interior%20lighting%2C%20realistic%20photography&width=900&height=600&seq=service-rewiring-worksop&orientation=landscape',
    description: 'A full house rewire is one of the most important electrical jobs you can have done. If your property is more than 25–30 years old and has never been rewired, it may present serious safety risks. Our rewiring service in Worksop covers everything from initial assessment to completion, with minimal disruption to your home.',
    when: [
      'Your property is over 25 years old',
      'Wiring is rubber or fabric-sheathed (pre-1970s)',
      'You\'re buying an older property',
      'Persistent electrical faults or tripping',
      'Extending or renovating your home',
      'Preparing for a property sale',
    ],
    benefits: [
      { icon: 'ri-award-fill', text: 'Certified to 18th Edition Wiring Regs' },
      { icon: 'ri-file-check-fill', text: 'Full electrical certificate on completion' },
      { icon: 'ri-brush-fill', text: 'Minimal disruption, tidy finish' },
      { icon: 'ri-money-pound-circle-fill', text: 'Competitive, honest quotes' },
    ],
  },
  {
    id: 'fuse-board',
    slug: 'fuse-board-upgrade-worksop',
    icon: 'ri-dashboard-fill',
    badge: 'REQUIRED FOR INSURANCE',
    badgeColor: 'bg-orange-100 text-orange-700',
    title: 'Fuse Board Upgrade Worksop',
    subtitle: 'Modern Consumer Unit Installations — Safe & Certified',
    image: 'https://readdy.ai/api/search-image?query=electrician%20installing%20new%20modern%20white%20consumer%20unit%20fuse%20board%20on%20wall%20of%20UK%20home%2C%20circuit%20breakers%20and%20RCD%20fitted%2C%20professional%20electrical%20upgrade%2C%20clean%20white%20background%20wall%2C%20neat%20cable%20management%2C%20bright%20lighting%2C%20realistic%20trade%20photography&width=900&height=600&seq=service-fuseboard-worksop&orientation=landscape',
    description: 'An outdated fuse board (or consumer unit) is a fire and safety risk. Modern consumer units include residual current devices (RCDs) and arc fault detection devices (AFDDs) that protect your home and family. Many insurers now require a modern consumer unit — we can upgrade yours quickly and with minimal disruption.',
    when: [
      'Your fuse box uses old-style wire fuses',
      'Your insurance company has flagged it',
      'Circuit breakers trip frequently',
      'You\'re installing a new electric vehicle charger',
      'Adding a major new appliance like a hot tub',
      'Your current board has no RCD protection',
    ],
    benefits: [
      { icon: 'ri-shield-check-fill', text: 'Meets latest 18th Edition regulations' },
      { icon: 'ri-home-heart-fill', text: 'Enhanced family safety with RCD protection' },
      { icon: 'ri-bank-fill', text: 'Satisfies insurance requirements' },
      { icon: 'ri-time-fill', text: 'Usually completed in one day' },
    ],
  },
  {
    id: 'eicr',
    slug: 'eicr-certificate-worksop',
    icon: 'ri-file-check-fill',
    badge: 'LEGALLY REQUIRED FOR LANDLORDS',
    badgeColor: 'bg-green-100 text-green-700',
    title: 'EICR Certificate Worksop',
    subtitle: 'Electrical Installation Condition Reports — Fast Turnaround',
    image: 'https://readdy.ai/api/search-image?query=electrician%20conducting%20electrical%20installation%20condition%20report%20inspection%20with%20professional%20digital%20testing%20equipment%2C%20electrical%20circuit%20testing%20in%20residential%20home%2C%20official%20inspection%20tools%2C%20clipboard%20with%20test%20certificate%2C%20warm%20lighting%2C%20realistic%20UK%20trade%20photography&width=900&height=600&seq=service-eicr-worksop&orientation=landscape',
    description: 'An Electrical Installation Condition Report (EICR) is a thorough inspection and test of your electrical installation. For landlords in England, it is a legal requirement every 5 years. For homeowners, it\'s strongly recommended when buying a property or if you\'ve not had an inspection in the last 10 years. We issue certificates same-day in most cases.',
    when: [
      'You\'re a landlord (legally required every 5 years)',
      'Buying or selling a property',
      'Your home insurance requires it',
      'You\'ve recently moved into an older property',
      'Requesting a mortgage on an older property',
      'No electrical inspection in over 10 years',
    ],
    benefits: [
      { icon: 'ri-file-check-fill', text: 'Certificates issued same day' },
      { icon: 'ri-user-star-fill', text: 'NAPIT approved inspection' },
      { icon: 'ri-building-fill', text: 'Covers residential & rental properties' },
      { icon: 'ri-money-pound-circle-fill', text: 'Competitive landlord rates' },
    ],
  },
  {
    id: 'domestic',
    slug: 'domestic-electrician-worksop',
    icon: 'ri-home-gear-fill',
    badge: 'GENERAL ELECTRICS',
    badgeColor: 'bg-blue-100 text-blue-700',
    title: 'Domestic Electrician Worksop',
    subtitle: 'All General Electrical Work for Your Home',
    image: 'https://readdy.ai/api/search-image?query=domestic%20electrician%20installing%20new%20electrical%20socket%20outlet%20on%20wall%20in%20bright%20modern%20UK%20home%20interior%2C%20professional%20domestic%20electrical%20work%2C%20white%20sockets%2C%20clean%20plasterwork%2C%20natural%20lighting%2C%20realistic%20photography&width=900&height=600&seq=service-domestic-worksop&orientation=landscape',
    description: 'From adding extra sockets to installing outdoor lighting, our domestic electrician service in Worksop covers all the general electrical work your home needs. We\'re happy to tackle jobs big and small — no job is too minor. We provide a neat, certified finish every time.',
    when: [
      'Adding new sockets or USB outlets',
      'Installing LED lighting or downlights',
      'Fitting outdoor or garden lighting',
      'Adding an electric vehicle charging point',
      'Installing a bathroom extractor fan',
      'Connecting new appliances or kitchen electrics',
    ],
    benefits: [
      { icon: 'ri-brush-fill', text: 'Tidy, plaster-ready finish' },
      { icon: 'ri-file-check-fill', text: 'All work certified (Part P)' },
      { icon: 'ri-calendar-check-fill', text: 'Flexible appointment times' },
      { icon: 'ri-money-pound-circle-fill', text: 'No job too small, fair pricing' },
    ],
  },
];

const servicesJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': `${siteUrl}/services#webpage`,
    url: `${siteUrl}/services`,
    name: 'Electrical Services Worksop | Rewiring, EICR, Fuse Board & More',
    description:
      'Full range of electrical services in Worksop — urgent callouts, house rewiring, fuse board upgrades, EICR certificates and domestic electrical work.',
    isPartOf: { '@id': `${siteUrl}/#website` },
    about: { '@id': `${siteUrl}/#business` },
    inLanguage: 'en-GB',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: `${siteUrl}/` },
      { '@type': 'ListItem', position: 2, name: 'Services', item: `${siteUrl}/services` },
    ],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'Electrical Services in Worksop',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        item: {
          '@type': 'Service',
          name: 'Urgent Electrician Worksop',
          description: 'Fast-response electrical callout service across Worksop and surrounding areas.',
          provider: { '@id': `${siteUrl}/#business` },
          areaServed: { '@type': 'City', name: 'Worksop' },
        },
      },
      {
        '@type': 'ListItem',
        position: 2,
        item: {
          '@type': 'Service',
          name: 'House Rewiring Worksop',
          description: 'Complete house rewiring by qualified electricians in Worksop, certified to 18th Edition Wiring Regulations.',
          provider: { '@id': `${siteUrl}/#business` },
          areaServed: { '@type': 'City', name: 'Worksop' },
        },
      },
      {
        '@type': 'ListItem',
        position: 3,
        item: {
          '@type': 'Service',
          name: 'Fuse Board Upgrade Worksop',
          description: 'Modern consumer unit installation in Worksop — safe, certified, and satisfies insurance requirements.',
          provider: { '@id': `${siteUrl}/#business` },
          areaServed: { '@type': 'City', name: 'Worksop' },
        },
      },
      {
        '@type': 'ListItem',
        position: 4,
        item: {
          '@type': 'Service',
          name: 'EICR Certificate Worksop',
          description: 'Electrical Installation Condition Reports for landlords and homeowners in Worksop. Certificates issued same day.',
          provider: { '@id': `${siteUrl}/#business` },
          areaServed: { '@type': 'City', name: 'Worksop' },
        },
      },
      {
        '@type': 'ListItem',
        position: 5,
        item: {
          '@type': 'Service',
          name: 'Domestic Electrician Worksop',
          description: 'All general domestic electrical work in Worksop — sockets, lighting, EV chargers, extractor fans and more.',
          provider: { '@id': `${siteUrl}/#business` },
          areaServed: { '@type': 'City', name: 'Worksop' },
        },
      },
    ],
  },
];

export default function ServicesPage() {
  const [activeService, setActiveService] = useState(services[0].id);
  const current = services.find((s) => s.id === activeService) ?? services[0];

  return (
    <div className="min-h-screen bg-white font-body">
      <SEOHead
        title="Electrical Services Worksop | Rewiring, EICR, Fuse Board & More"
        description="Full range of electrical services in Worksop — urgent callouts, house rewiring, fuse board upgrades, EICR certificates and domestic electrical work. NAPIT registered."
        keywords="electrical services Worksop, electrician Worksop, rewiring Worksop, fuse board upgrade Worksop, EICR certificate Worksop, domestic electrician Worksop"
        canonical={`${siteUrl}/services`}
        ogTitle="Electrical Services Worksop | Rewiring, EICR, Fuse Board & More"
        ogDescription="Professional electrical services across Worksop — urgent callouts, rewiring, fuse board upgrades, EICR. Fully insured &amp; NAPIT registered."
        ogUrl={`${siteUrl}/services`}
        ogImage={SERVICES_OG_IMAGE}
        jsonLd={servicesJsonLd}
      />
      <Navbar />

      {/* Hero */}
      <section className="relative bg-navy-800 pt-32 pb-16">
        <div className="absolute inset-0 opacity-20">
          <img
            src="https://readdy.ai/api/search-image?query=professional%20electrician%20tools%20and%20equipment%20laid%20out%20neatly%20on%20workbench%2C%20multimeter%20cable%20stripper%20screwdrivers%20voltage%20tester%2C%20professional%20trade%20tools%2C%20dark%20navy%20background%2C%20dramatic%20lighting%2C%20realistic%20photography&width=1600&height=500&seq=services-hero-tools&orientation=landscape"
            alt=""
            className="w-full h-full object-cover object-center"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-navy-900/60 to-navy-800"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-6">
          <nav className="flex items-center gap-2 text-sm text-gray-400 mb-6 font-body">
            <Link to="/" className="hover:text-gold-400 cursor-pointer">Home</Link>
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-s-line text-gray-500"></i>
            </span>
            <span className="text-gold-400">Services</span>
          </nav>
          <h1 className="font-heading font-extrabold text-white text-5xl mb-4">
            Electrical Services in <span className="text-gold-400">Worksop</span>
          </h1>
          <p className="text-gray-300 text-lg max-w-2xl leading-relaxed">
            From urgent callouts to full rewires, EICR certificates to fuse board upgrades — professional electrical services across Worksop, Retford, and North Nottinghamshire.
          </p>
        </div>
      </section>

      {/* Service Tabs */}
      <section className="border-b border-gray-200 bg-white sticky top-8 z-40">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex items-center gap-1 overflow-x-auto py-3 scrollbar-hide">
            {services.map((svc) => (
              <button
                key={svc.id}
                onClick={() => setActiveService(svc.id)}
                className={`flex items-center gap-2 px-5 py-2.5 rounded-md font-semibold text-sm transition-all whitespace-nowrap cursor-pointer ${
                  activeService === svc.id
                    ? 'bg-gold-400 text-navy-800'
                    : 'text-gray-500 hover:text-navy-800 hover:bg-gray-100'
                }`}
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className={`${svc.icon} text-sm`}></i>
                </span>
                {svc.title.split(' ').slice(0, 2).join(' ')}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Active Service Detail */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
            {/* Main Content */}
            <div className="lg:col-span-2">
              {/* Image */}
              <div className="rounded-xl overflow-hidden mb-8" style={{ height: '380px' }}>
                <img
                  src={current.image}
                  alt={current.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Badge + Title */}
              <span className={`inline-block text-xs font-bold uppercase tracking-widest px-3 py-1.5 rounded-full mb-4 ${current.badgeColor}`}>
                {current.badge}
              </span>
              <h2 className="font-heading font-extrabold text-navy-800 text-4xl mb-3">{current.title}</h2>
              <p className="text-amber-600 font-semibold text-base mb-5">{current.subtitle}</p>
              <p className="text-gray-600 leading-relaxed mb-8 text-base">{current.description}</p>

              {/* When you need it */}
              <h3 className="font-heading font-bold text-navy-800 text-xl mb-4">When Do You Need This Service?</h3>
              <ul className="space-y-2.5 mb-10">
                {current.when.map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <span className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                      <i className="ri-checkbox-circle-fill text-amber-500 text-lg"></i>
                    </span>
                    <span className="text-gray-600 text-sm leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>

              {/* Benefits */}
              <h3 className="font-heading font-bold text-navy-800 text-xl mb-5">Why Choose Us?</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {current.benefits.map((b) => (
                  <div key={b.text} className="flex items-center gap-3 bg-gray-50 rounded-lg p-4 border border-gray-100">
                    <span className="w-9 h-9 flex items-center justify-center bg-amber-100 rounded-lg flex-shrink-0">
                      <i className={`${b.icon} text-amber-600 text-lg`}></i>
                    </span>
                    <p className="text-navy-800 font-semibold text-sm">{b.text}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Sidebar */}
            <div className="lg:col-span-1">
              <div className="sticky top-28">
                {/* Quote Form */}
                <div className="bg-navy-800 rounded-xl p-7 mb-6 border-2 border-amber-500">
                  <h3 className="font-heading font-bold text-white text-xl mb-2">Get a Free Quote</h3>
                  <p className="text-gray-400 text-sm mb-5">Tell us what you need and we&apos;ll get back to you the same day.</p>
                  <form
                    data-readdy-form
                    id="services-quote-form"
                    action="https://readdy.ai/api/form/d6v9d6vb245v7h34okq0"
                    method="POST"
                    onSubmit={async (e) => {
                      e.preventDefault();
                      const form = e.currentTarget;
                      const formData = new FormData(form);
                      const body = new URLSearchParams();
                      formData.forEach((value, key) => { body.append(key, value.toString()); });
                      try {
                        await fetch('https://readdy.ai/api/form/d6v9d6vb245v7h34okq0', {
                          method: 'POST',
                          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                          body: body.toString(),
                        });
                        form.reset();
                        alert('Thank you! We\'ll be in touch very soon.');
                      } catch {
                        alert('Something went wrong. Please call us directly.');
                      }
                    }}
                    className="space-y-3"
                  >
                    <input
                      name="name"
                      type="text"
                      placeholder="Your Name"
                      required
                      className="w-full bg-navy-700 border border-navy-600 text-white placeholder-gray-400 rounded-md px-4 py-3 text-sm focus:outline-none focus:border-amber-500"
                    />
                    <input
                      name="email"
                      type="email"
                      placeholder="Email Address"
                      required
                      className="w-full bg-navy-700 border border-navy-600 text-white placeholder-gray-400 rounded-md px-4 py-3 text-sm focus:outline-none focus:border-amber-500"
                    />
                    <input
                      name="phone"
                      type="tel"
                      placeholder="Phone Number"
                      required
                      className="w-full bg-navy-700 border border-navy-600 text-white placeholder-gray-400 rounded-md px-4 py-3 text-sm focus:outline-none focus:border-amber-500"
                    />
                    <select
                      name="service"
                      defaultValue={current.title}
                      className="w-full bg-navy-700 border border-navy-600 text-white rounded-md px-4 py-3 text-sm focus:outline-none focus:border-amber-500"
                    >
                      {services.map((s) => (
                        <option key={s.id} value={s.title}>{s.title}</option>
                      ))}
                    </select>
                    <textarea
                      name="message"
                      placeholder="Briefly describe your job..."
                      rows={3}
                      maxLength={500}
                      className="w-full bg-navy-700 border border-navy-600 text-white placeholder-gray-400 rounded-md px-4 py-3 text-sm focus:outline-none focus:border-amber-500 resize-none"
                    ></textarea>
                    <button
                      type="submit"
                      className="w-full bg-amber-500 hover:bg-amber-400 text-navy-800 font-bold text-sm py-3.5 rounded-md transition-colors cursor-pointer whitespace-nowrap"
                    >
                      Request Free Quote
                    </button>
                  </form>
                </div>

                {/* Phone CTA */}
                <div className="bg-amber-50 border border-amber-200 rounded-xl p-6 text-center">
                  <div className="w-12 h-12 flex items-center justify-center bg-amber-500 rounded-full mx-auto mb-3">
                    <i className="ri-phone-fill text-navy-800 text-xl"></i>
                  </div>
                  <p className="font-heading font-bold text-navy-800 text-lg mb-1">Prefer to call?</p>
                  <p className="text-gray-500 text-sm mb-4">Call us for a free quote — no obligation</p>
                  <a
                    href={`tel:${PHONE.replace(/\s/g, '')}`}
                    className="block bg-amber-500 hover:bg-amber-400 text-navy-800 font-bold text-base py-3 rounded-md transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {PHONE}
                  </a>
                </div>

                {/* Trust badges */}
                <div className="mt-4 grid grid-cols-3 gap-2">
                  {[
                    { icon: 'ri-shield-check-fill', label: 'Insured' },
                    { icon: 'ri-award-fill', label: 'NAPIT' },
                    { icon: 'ri-star-fill', label: '5-Star' },
                  ].map((b) => (
                    <div key={b.label} className="flex flex-col items-center gap-1 bg-gray-50 border border-gray-100 rounded-lg p-3">
                      <span className="w-6 h-6 flex items-center justify-center">
                        <i className={`${b.icon} text-amber-500 text-lg`}></i>
                      </span>
                      <span className="text-xs font-semibold text-navy-800 text-center leading-tight">{b.label}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Bottom CTA */}
      <section className="py-14 bg-gray-50 border-t border-gray-200">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h3 className="font-heading font-extrabold text-navy-800 text-3xl mb-3">
            Ready to Book?
          </h3>
          <p className="text-gray-500 mb-8">Call us now for a free quote or to book your appointment. No call-out charge for estimates.</p>
          <a
            href={`tel:${PHONE.replace(/\s/g, '')}`}
            className="inline-flex items-center gap-3 bg-amber-500 hover:bg-amber-400 text-navy-800 font-bold text-lg px-10 py-4 rounded-md transition-colors cursor-pointer whitespace-nowrap"
          >
            <span className="w-6 h-6 flex items-center justify-center">
              <i className="ri-phone-fill text-xl"></i>
            </span>
            Call {PHONE}
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
